import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { sessionApiStore } from "@/hooks";
import {
  PasswordInput,
  Typography,
  PanelCard,
  TextButton,
} from "@/components/common";


/**
 * Displays account deletion.
 */
const __default__ = {
  name: "DeleteAccount",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const password = ref("");

/**
 * Handles account deletion.
 */
function handleSubmit(): void {
  sessionApiStore.handleDeleteAccount(password.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    color: "negative",
    title: "Delete Account"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        label: "Delete My Account",
        outlined: "",
        color: "negative",
        disabled: !password.value,
        "data-cy": "button-delete-my-account",
        onClick: handleSubmit
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Typography), {
        el: "p",
        value: "Type in your current password to delete your account."
      }),
      _createVNode(_unref(PasswordInput), {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        label: "Password",
        "data-cy": "input-delete-password"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})